<template>
  <div class="w120 mc mt20 bg-w">
    <p class="pt20 pb20 w100 tx-c font-18">我的收藏</p>
    <div class="w100 po-r pl20 pr20 pb20" style="min-height: 150px;" v-loading="loading" element-loading-text="正在查询，请稍后" element-loading-background="rgba(0, 0, 0, 0.8)">
      <el-row class="w100" :gutter="16" v-if="data.length > 0">
        <el-col class="set20" :span="4" v-for="(val, key) in data" :key="key">
          <div class="po-r w100 bg-ww of-h search-list">
            <p class="po-r w100 bor-b font-14 pl10 title grey ellipsis">{{ val.SERVETITLE }}</p>
            <div class="po-r w100 search-list-main">
              <img :src="val.PROCESSLOGODL ? val.PROCESSLOGODL : baseUrl + 'images/icon-app.png'">
              <p class="w100 ellipsis font-14">{{ val.SERVENAME }}</p>
              <div class="w100 star">
                <el-rate :value="val.SCORE / 2" allow-half disabled></el-rate>
              </div>
              <p class="w100 font-12 grey ellipsis">{{ val.CONUM }}人收藏</p>
            </div>
            <div class="po-a w100 h100 bg-w search-list-hover">
              <!-- <div class="pt5 pb5 pl10 pr10 font-14 ellipsis-2">{{ val.SERVENAME }}</div>
              <div class="po-r w100 pl10 pr10 grey ellipsis-2">{{ val.msg ? val.msg : '简介' }}</div> -->
              <div class="po-a w100 tx-c white flex-box search-list-hover-btn">
                <div class="flex-1 cu-p" style="background: #445eb5;" @click="clickCollect(key, val.SERVEID)">
                  <i class="el-icon-star-on"></i>
                  取消收藏
                </div>
                <router-link key="serveType" v-if="val.SERVETYPE == 1" :to="{ name: `server_info`, query:{ id: val.SERVEID }}" class="flex-1 white" style="background: #4a66cd;">进入</router-link>
                <router-link key="serveType" v-else-if="val.SERVETYPE == 0" :to="{ name: `server_search`, query:{ id: val.SERVEID, interfaceUrl: val.INTERFACEURL ? val.INTERFACEURL.replace(/\/| /g,'') : null }}" class="flex-1 white" style="background: #4a66cd;">进入</router-link>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="w100 mt20 tx-r" v-show="total > 0">
        <el-pagination @size-change="changeSize" @current-change="changePage" :current-page="page" :page-sizes="[30, 50, 100]" :page-size="size" layout="total, sizes, prev, pager, next, jumper" background :total="total"></el-pagination>
      </div>

      <p class="w100 tx-c pt20 pb20 grey font-16" v-if="data.length == 0 && !loading">暂无收藏数据...</p>

      <div class="w100 pt20 pb20 tx-c" v-if="error == 404">
        <el-button plain @click="error = 0, fetchData()">加载失败，点击重新加载</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "collect",
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      error: 0,

      page: 1,
      total: 0,
      size: 30,
      data: []
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;

      this.$http
        .post(
          "serveCollection/getAllData",
          this.$qs.stringify({
            target: this.userData.userId,
            pageNum: this.page,
            pageSize: this.size
          })
        )
        .then(({ data }) => {
          // console.log(data.resData);
          if (data.resCode == 0 && data.resStatus == 0) {
            this.data = data.resData.list;
            this.total = data.resData.total;
          }

          this.error = 0;
          this.loading = false;
        })
        .catch(({ error }) => {
          this.error = 404;
          this.loading = false;
        });
    },
    clickCollect(key, id) {
      this.$http
        .post(
          `serveCollection/delCo`,
          this.$qs.stringify({
            userId: this.userData.userId,
            serveId: id
          })
        )
        .then(({ data }) => {
          if (data.resStatus == 0) {
            this.data.splice(key, 1);
            this.total--;
            this.$notify({
              title: "成功",
              message: data.resMsg,
              type: "success",
              offset: 60
            });
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "操作失败，请检查网络",
            type: "error",
            offset: 60
          });
        });
    },
    changeSize(value) {
      this.size = value;
      this.fetchData();
    },
    changePage(value) {
      this.page = value;
      this.fetchData();
    }
  }
};
</script>

<style scoped>
.search-list-hover {
  top: 100%;
  left: 0;
  border-radius: 8px;
  transition: top 0.2s;
  background: none;
}

.search-list-hover-btn {
  bottom: 0;
  left: 0;
  height: 35px;
  line-height: 35px;
}

.search-list:hover .search-list-hover {
  top: 0;
}

.search-bg {
  box-shadow: 0 3px 4px -1px rgba(0, 0, 0, 0.2);
}

.search-app {
  display: flex;
  padding: 0 10px 0 70px;
  height: 60px;
  align-items: center;
}

.search-app img {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  width: 50px;
  height: 50px;
}

.search-main {
  padding: 40px 20px 20px 39px;
  border-left: 1px solid #ccc;
}

.search-list-title .title {
  padding: 0 15px;
  height: 40px;
}

.search-list-title .title::before {
  content: "";
  display: block;
  position: absolute;
  left: -51px;
  top: 50%;
  transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 3px solid #fff;
  background: #7085d7;
}

.search-list-title .title::after {
  content: "";
  display: block;
  position: absolute;
  left: -29px;
  top: 50%;
  transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  width: 29px;
  height: 1px;
  background: #7085d7;
}

.search-list-title .sanjiao {
  padding: 0 16px;
  background: #7085d7;
}

.search-list-title .sanjiao::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: -40px;
  height: 0;
  width: 0;
  border: 20px solid transparent;
  border-right: 20px solid #7085d7;
}

.search-list-title .sanjiao::after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: -40px;
  height: 0;
  width: 0;
  border: 20px solid transparent;
  border-left: 20px solid #7085d7;
}

.set20 {
  width: 20%;
}

.search-list {
  margin: 8px 0;
  height: 128px;
  border-radius: 8px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12);
}

.search-list .title {
  padding-right: 30px;
  height: 30px;
  line-height: 30px;
}

.search-list .title::after {
  content: "";
  display: block;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  width: 14px;
  height: 14px;
  background: #eeeeee;
  border-radius: 50%;
}

.search-list-main {
  padding: 20px 10px 10px 80px;
}

.search-list-main img {
  position: absolute;
  width: 54px;
  height: 54px;
  left: 14px;
  top: 22px;
}
</style>

<style>
.search-list-main .star i {
  margin-right: 2px;
  font-size: 14px;
}

.server-radio .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #475eb7;
  border-color: #475eb7;
}
</style>
